import CaseStudiesPreview from "../../../Components/CaseStudiesPreview/CaseStudiesPreview";
import ApproachSection from "./ApproachSection";
import IntroductionSection from "./IntroductionSection";
import StrengthSection from "./StrengthSection";
import ContactSection from "./ContactSection";

export default function Blockchain() {
  return (
    <>
      <IntroductionSection />
      <StrengthSection />
      <ApproachSection />
      <CaseStudiesPreview />
      <ContactSection />
    </>
  );
}
